import { FC } from 'react';
import ProRadio, { RadioProps } from './radio';
import ProRadioGroup, { RadioGroupProps } from './group';
import ProRadioButton, { RadioButtonProps } from './button';

export type IRadioComponent = FC<
  RadioProps & React.RefAttributes<HTMLElement>
> & {
  Group: FC<RadioGroupProps & React.RefAttributes<HTMLElement>>;
  Button: FC<RadioButtonProps & React.RefAttributes<HTMLElement>>;
};

const TransRadio = ProRadio as IRadioComponent;
TransRadio.Group = ProRadioGroup;
TransRadio.Button = ProRadioButton;

export default TransRadio;
